import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function TheProblem() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-cream py-16 md:py-24 px-6" data-id="element-149">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.7
    }} className="max-w-4xl mx-auto" data-id="element-150">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-warm-brown mb-8 text-center" data-id="element-151">
          ¿Por qué fallan la mayoría de las técnicas de sueño?
        </h2>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg" data-id="element-152">
          <p className="text-lg md:text-xl text-warm-brown leading-relaxed mb-6" data-id="element-153">
            La mayoría de las técnicas de sueño fallan porque intentan
            "adiestrar" al bebé. Te dicen que lo dejes llorar hasta que se
            rinda, o que sigas rutinas rígidas de baño y masaje que simplemente
            no funcionan cuando el sistema nervioso de tu pequeño está en alerta
            roja.
          </p>
          <p className="text-lg md:text-xl text-warm-brown leading-relaxed" data-id="element-154">
            Cuando un bebé está sobre-estimulado, su cuerpo produce cortisol y
            adrenalina. Intentar dormirlo en ese estado es como pedirle a un
            corredor de 100 metros que se detenga y se duerma en plena carrera.
            Sin el mecanismo de "aterrizaje" correcto, el llanto es inevitable y
            el agotamiento de ambos se vuelve crónico.
          </p>
        </div>
      </motion.div>
    </section>;
}